"use strict";

exports.__esModule = true;
exports.onInitialClientRender = void 0;
var _2 = require("./");
const onInitialClientRender = (_, pluginOptions) => {
  var _pluginOptions$attrib;
  const attributeName = (_pluginOptions$attrib = pluginOptions.attributeName) !== null && _pluginOptions$attrib !== void 0 ? _pluginOptions$attrib : _2.defaultOptions.attributeName;
  try {
    // eslint-disable-next-line @typescript-eslint/no-dynamic-delete -- delete dataset
    delete window.document.body.dataset[(0, _2.toCamelCase)(attributeName)];
  } catch (e) {}
};
exports.onInitialClientRender = onInitialClientRender;